import { AUDIENCE_ICONS, AUDIENCE_IMAGES } from "@/mock";
import { useLanguage } from "@/i18n/LanguageContext";

const WhoIsItFor = () => {
  const { t } = useLanguage();
  return (
    <section id="audience" data-testid="audience-section" className="bg-[#F4F4F2] pt-4 pb-8 md:pt-5 md:pb-10">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-8">
        <div className="reveal mb-10">
          <div className="text-[#2E4FE6] font-bold text-xs tracking-[0.22em] uppercase mb-5 mx-auto">{t.audience.eyebrow}</div>
          <h2 className="font-display text-[clamp(1.7rem,4.5vw,3.8rem)] uppercase text-[#111] break-words">{t.audience.title}</h2>
        </div>
        <div className="flex flex-wrap justify-center gap-5">
          {t.audience.items.map((a, i) => {
            const Icon = AUDIENCE_ICONS[i];
            return (
              <div
                key={i}
                data-testid={`audience-card-${i}`}
                className="reveal group relative overflow-hidden rounded-lg cursor-pointer w-full aspect-[16/9] sm:aspect-[3/4] sm:w-[calc(50%-10px)] md:w-[calc(33.333%-14px)] xl:w-[calc(20%-16px)]"
                style={{ animationDelay: `${i * 0.06}s` }}
              >
                <img src={AUDIENCE_IMAGES[i]} alt={a.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
                <div className="absolute top-4 left-4 w-9 h-9 rounded-md bg-white flex items-center justify-center">
                  <Icon className="w-[18px] h-[18px] text-[#2E4FE6]" strokeWidth={2} />
                </div>
                <div className="absolute bottom-0 left-0 right-0 px-3 pt-5 pb-6 text-center">
                  <h3 className={`font-display uppercase text-white mb-2 text-lg text-center ${a.title.length >= 12 ? "tracking-tight" : ""}`}>{a.title}</h3>
                  <p className="text-white/0 group-hover:text-white/90 text-sm leading-snug max-h-0 group-hover:max-h-32 overflow-hidden transition-all duration-500">
                    {a.text}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhoIsItFor;
